import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import close from "../../../assets/icons/close.svg";

export interface DialogProps {
  onClose: () => void;
  shouldScroll?: boolean;
  children: React.ReactNode;
  dismissible?: boolean;
}

export default function Dialog(props: DialogProps) {
  const queryClient = new QueryClient();
  const shouldScroll: boolean = props.shouldScroll ?? true;
  return (
    <div
      onClick={(props.dismissible ?? true) ? props.onClose : undefined}
      className="z-40 fixed flex justify-center items-center h-full w-full bg-black/85"
    >
      <div
        className={`max-h-[75%] max-w-full relative flex flex-col rounded-xl bg-gradient-to-b from-cinder-dark to-bastille shadow-lg`}
      >
        <button
          className="z-50"
          onClick={(e) => {
            e.stopPropagation();
            props.onClose();
          }}
        >
          <img
            src={close}
            className="absolute top-0 right-0 ~h-5/6 p-1 ~m-2/3"
            alt="close"
          />
        </button>
        <div
          onClick={(e) => e.stopPropagation()}
          className={`max-h-[75%] ~py-8/10 ~px-8/10 flex flex-col items-center ${shouldScroll ? "overflow-y-scroll" : "overflow-y-hidden"}`}
        >
          <QueryClientProvider client={queryClient}>
            {props.children}
          </QueryClientProvider>
        </div>
      </div>
    </div>
  );
}
